import { render, staticRenderFns } from "./openBillDetail.vue?vue&type=template&id=1c6ba316&scoped=true"
import script from "./openBillDetail.vue?vue&type=script&lang=js"
export * from "./openBillDetail.vue?vue&type=script&lang=js"
import style0 from "@/assets/public.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./openBillDetail.vue?vue&type=style&index=1&id=1c6ba316&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6ba316",
  null
  
)

export default component.exports